var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.4999L13 22.4999C12.2044 22.4999 11.4413 22.1838 10.8787 21.6212C10.3161 21.0586 10 20.2955 10 19.4999V15.4999H4.34003C4.05012 15.5032 3.76297 15.4434 3.49846 15.3247C3.23395 15.2059 2.99842 15.0311 2.80817 14.8124C2.61793 14.5936 2.47753 14.3361 2.39669 14.0576C2.31586 13.7792 2.29652 13.4865 2.34003 13.1999L3.72003 4.19987C3.79235 3.72297 4.0346 3.28827 4.40212 2.97587C4.76965 2.66347 5.2377 2.49442 5.72003 2.49987H17M17 13.4999V2.49987M17 13.4999H19.67C20.236 13.5099 20.7859 13.3117 21.2154 12.9431C21.645 12.5744 21.9242 12.0608 22 11.4999V4.49987C21.9242 3.93893 21.645 3.42538 21.2154 3.05669C20.7859 2.68801 20.236 2.48986 19.67 2.49987H17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownWhite);
export default __webpack_public_path__ + "static/media/thumbs-down-white.2bdbd84455b58ebc8290021d958c46f4.svg";
export { ForwardRef as ReactComponent };